import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { theme } from '../config/theme';
import { Button } from '../junto-frontend/components/ui';
import { useBackButton } from '../contexts/BackButtonContext';

const BackButtonContainer = styled.div`
  position: fixed;
  top: calc(var(--nav-height, 128px) + 18px); /* Dynamic navigation height + small offset */
  left: 40px;
  z-index: 100;

  @media (max-width: ${theme.breakpoints.tablet}) {
    /* Hide on mobile when Navigation handles the back button */
    display: ${props => props.$hideOnMobile ? 'none' : 'block'};
    position: static;
    padding: ${theme.spacing.md} ${theme.spacing.layoutGutter};
    text-align: center;
  }
`;

const BackButton = ({ 
  text = "← Back", 
  to = "/", 
  onClick,
  ...props 
}) => {
  const { backButtonInfo } = useBackButton();

  // Hide on mobile when Navigation is handling the back button
  const hideOnMobile = !!backButtonInfo.text;

  return (
    <BackButtonContainer $hideOnMobile={hideOnMobile}>
      <Link to={to} style={{ textDecoration: 'none' }}>
        <Button variant="outline" size="medium" {...props}>{text}</Button>
      </Link>
    </BackButtonContainer>
  );
};

export default BackButton;